const ExportDefault = (props) => {
    const { component } = props;
    const renderer = component.getRenderer();

    return renderer(props);
};  

export default ExportDefault;